module.exports = __webpack_public_path__ + "img/engagementring.e2873cb.jpg";